import { TenantBranding } from './types';

/**
 * Neutral fallback branding — used while no tenant branding could be resolved
 * (e.g. Control Plane unreachable in dev). Matches Berry's `default` preset
 * primary/secondary so the UI still looks coherent, but it is ONLY a fallback:
 * the real theme always comes from the Control Plane branding response [STD-FE].
 */
export const defaultBranding: TenantBranding = {
  colors: {
    primaryMain: '#2196f3',
    primaryLight: '#e3f2fd',
    primaryDark: '#1e88e5',
    secondaryMain: '#673ab7',
    secondaryLight: '#ede7f6',
    secondaryDark: '#5e35b1'
  },
  logo: {},
  typography: {
    fontFamily: `'Roboto', sans-serif`
  },
  borderRadius: 8
};
